module.exports = __webpack_public_path__ + "static/media/clothes.5270dc82.jpg";